import React from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { AppBar, Card, Paper, Typography, Tooltip, Dialog, DialogContent, DialogTitle, Button } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { DataGrid } from "@mui/x-data-grid";
import { GET } from "APIclient";
import properties from "constants/ApplicationConstants";

export default function AssetHistory() {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const assetId = id || location.state?.assetId;

  const [rows, setRows] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const [dialogContent, setDialogContent] = React.useState("");

  const handleViewClick = (content) => {
    setDialogContent(content);
    setDialogOpen(true);
  };

  const columns = [
    { field: "id", headerName: "#", width: 20 },
    { field: "empId", headerName: "Emp ID", width: 70 },
    { field: "empName", headerName: "Employee Name", width: 130 },
    { field: "assignedDate", headerName: "Assigned Date", width: 120 },
    { field: "returnDate", headerName: "Returned Date", width: 120 },
    { field: "assignedBy", headerName: "Assigned By", width: 120 },
    { field: "returnTo", headerName: "Returned To", width: 120 },
    {
      field: "assignComment",
      headerName: "Assigned Comment",
      width: 160,
      renderCell: (params) => {
        const text = params.value || "";
        const truncated = text.length > 60 ? text.slice(0, 30) + "..." : text;
        return (
          <Tooltip title={text}>
            <Button
              variant="text"
              onClick={() => handleViewClick(text)}
              sx={{ textTransform: "none", padding: 0, minWidth: 0, color: "inherit", fontFamily: properties.fontFamily, fontSize: "12px" }}
            >
              {truncated}
            </Button>
          </Tooltip>
        );
      }
    },
    {
      field: "returnComment",
      headerName: "Returned Comment",
      width: 160,
      renderCell: (params) => {
        const text = params.value || "";
        const truncated = text.length > 60 ? text.slice(0, 30) + "..." : text;
        return (
          <Tooltip title={text}>
            <Button
              variant="text"
              onClick={() => handleViewClick(text)}
              sx={{ textTransform: "none", padding: 0, minWidth: 0, color: "inherit", fontFamily: properties.fontFamily, fontSize: "12px" }}
            >
              {truncated}
            </Button>
          </Tooltip>
        );
      }
    }
  ];

  React.useEffect(() => {
    const fetchHistory = async () => {
      if (!assetId) return;
      try {
        setLoading(true);
        const res = await GET(`it-dept/assets/assesthistory/${assetId}`);
        const list = res?.data?.data || [];
        const mapped = list.map((item, idx) => ({ id: idx + 1, ...item }));
        setRows(mapped);
      } catch (e) {
        console.error("Failed to fetch asset history", e);
        setRows([]);
      } finally {
        setLoading(false);
      }
    };
    fetchHistory();
  }, [assetId]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox>
        <AppBar position="static">
          <Card>
            <MDBox container pt={3} pb={3} px={3}>
              <MDBox
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center"
                }}
              >
              <Typography
                sx={{
                  color: "textPrimary",
                  fontFamily: properties.fontFamily,
                  fontSize: "16px",
                  fontWeight: "bold"
                }}
              >
                Asset History
              </Typography>
              <MDButton
                variant="outlined"
                color="secondary"
                onClick={() => navigate("/assetList")}
                sx={{ gridColumn: "span 2", fontFamily: properties.fontFamily }}
              >
                Back to Asset List
              </MDButton>
            </MDBox>
            </MDBox>
          </Card>
        </AppBar>

        <MDBox>
          <Paper>
            <DataGrid
              rows={rows}
              columns={columns}
              loading={loading}
              pageSizeOptions={[20]}
              sx={{
                fontFamily: properties.fontFamily,
                fontSize: "14px",
                fontWeight: 400,
                height: "500px",
                "& .MuiDataGrid-scrollbar": {
                  width: "10px !important"
                }
              }}
            />
          </Paper>
        </MDBox>
      </MDBox>
      
      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Comment</DialogTitle>
        <DialogContent>
          <Typography
            sx={{
              whiteSpace: "pre-line", 
              fontFamily: properties.fontFamily,
              fontSize:"14px",
              fontWeight:400
            }}
          >
            {dialogContent}
          </Typography>
        </DialogContent>
      </Dialog>
    </DashboardLayout>
  );
}
